// Modified from Dawn's FacetFiltersForm component
class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();

    this.sectionContainer = document.getElementById(
      "shopify-section-" + this.dataset.section
    );

    this.onFilterClick = this.onFilterClick.bind(this);

    this.bindEvents();

    this.scrollActiveMenus(false);

    this.parentDrawer = this.closest("menu-drawer");
    const parentDrawerToggle =
      this.parentDrawer && this.parentDrawer.querySelector("details");

    if (parentDrawerToggle) {
      parentDrawerToggle.addEventListener("toggle", (e) => {
        if (e.currentTarget.open) {
          this.scrollActiveMenus(false);
        }
      });
    }
  }

  bindEvents() {
    Array.from(this.querySelectorAll(".collection-filter-link")).forEach(
      (link) => {
        link.addEventListener("click", this.onFilterClick);
      }
    );
    if (this.parentDrawer) {
      this.parentDrawer.bindEvents();
    }
  }

  scrollActiveMenus(animate = false) {
    const menus = Array.from(this.querySelectorAll(".collection-filter-menu"));
    menus.forEach((menu) => this.scrollToActiveMenuItem(menu, animate));
  }
  scrollToActiveMenuItem(menu, animate = false) {
    if (menu.scrollWidth <= menu.clientWidth) {
      return;
    }
    const activeItem = menu.querySelector(".btn--toggle-selected");
    if (!activeItem) {
      return;
    }
    const scrollLeft =
      activeItem.offsetLeft + (activeItem.clientWidth - menu.clientWidth) / 2;
    menu.scrollTo({
      left: scrollLeft,
      behavior: animate ? "smooth" : "auto",
    });
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const filterUrl = event.state
        ? event.state.filterUrl
        : FacetFiltersForm.filterUrlInitial;
      if (filterUrl === FacetFiltersForm.filterUrlPrev) return;
      FacetFiltersForm.renderPage(filterUrl, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable);
    });
  }

  static renderPage(filterUrl, event, updateURLHash = true) {
    FacetFiltersForm.filterUrlPrev = filterUrl;
    const sections = FacetFiltersForm.getSections();
    document
      .getElementById("ProductGridContainer")
      .querySelector(".product-grid__inner")
      .classList.add("loading");

    const sectionParamPrefix =
      filterUrl.indexOf("?") === -1 ? "?section_id=" : "&section_id=";

    sections.forEach((section) => {
      const url = `${filterUrl}${sectionParamPrefix}${section.section}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(filterUrl);
  }

  static renderSection(html, event) {
    FacetFiltersForm.renderFilterMenus(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ];
        FacetFiltersForm.renderSection(html, event);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderSection(html, event);
  }

  static renderProductGridContainer(html) {
    const productGridContainer = document.getElementById(
      "ProductGridContainer"
    );

    const sourceGrid = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductGridContainer");
    if (sourceGrid && productGridContainer) {
      FacetFiltersForm.updateCardPrices(sourceGrid);

      productGridContainer.innerHTML = sourceGrid.innerHTML;

      if (sourceGrid.dataset.pageTitle) {
        document.title = sourceGrid.dataset.pageTitle;
      }
    }

    productGridContainer
      .querySelectorAll(".scroll-trigger")
      .forEach((element) => {
        element.classList.add("scroll-trigger--cancel");
      });
  }

  static replaceContent(sourceDocument, selector) {
    const sourceEl = sourceDocument.querySelector(selector);
    const destinationEl = document.querySelector(selector);
    if (sourceEl && destinationEl) {
      destinationEl.innerHTML = sourceEl.innerHTML;
      return destinationEl;
    }
  }

  static renderFilterMenus(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");

    const filterMenus = Array.from(
      document.querySelectorAll("facet-filters-form")
    );
    filterMenus.forEach((menu) => {
      if (menu.id) {
        const filterMenu = FacetFiltersForm.replaceContent(
          parsedHTML,
          "#" + menu.id
        );
        if (filterMenu) {
          filterMenu.bindEvents();
          filterMenu.scrollActiveMenus();
        }
      }
    });
  }

  static formatPrice(price, roundDown) {
    return (
      (window.currencySymbol || "$") +
      (roundDown
        ? Math.floor(price).toString()
        : price.toFixed(2).replace(".00", ""))
    );
  }

  static updateCardPrice(card, price, comparePrice, priceVaries) {
    if (isNaN(price)) {
      return;
    }
    const $priceContainer = card.querySelector(".product-price-container");
    const roundDown = $priceContainer.dataset.roundDown === "true";
    const $price = $priceContainer.querySelector(".product-price");
    const $comparePrice = $priceContainer.querySelector(
      ".product-compare-price"
    );
    if ($comparePrice && !isNaN(comparePrice)) {
      $comparePrice.textContent = FacetFiltersForm.formatPrice(
        comparePrice,
        roundDown
      );
    }
    if ($price) {
      $price.textContent =
        FacetFiltersForm.formatPrice(price, roundDown) +
        (priceVaries ? "+" : "");
    }
  }

  static updateCardPrices(grid) {
    try {
      if (!(grid && window.igData)) {
        return;
      }
      const cards = Array.from(grid.querySelectorAll(".product-card-wrapper"));

      cards.forEach((card) => {
        const variantId = card.dataset.variantId;
        if (card.dataset.bundleVariants) {
          const bundleDiscountFactor =
            1 - parseFloat(card.dataset.bundleDiscountPercentage) / 100;
          const bundleVariants = card.dataset.bundleVariants
            .split(",")
            .map((b) => b.split(":").map((i) => parseInt(i)));
          let hasTestPrice = false;
          const combinedPrice =
            bundleVariants.reduce((m, [id, defaultPrice, quantity]) => {
              const testPrice = igData.price.getPriceByVariantId(id);
              const price = testPrice
                ? parseFloat(testPrice) * 100
                : defaultPrice;
              if (testPrice) {
                hasTestPrice = true;
              }
              const linePrice =
                quantity * (isNaN(price) ? defaultPrice : price);
              return m + linePrice;
            }, 0) / 100;
          if (isNaN(combinedPrice) || !hasTestPrice) {
            return;
          }
          const $priceContainer = card.querySelector(
            ".product-price-container"
          );
          FacetFiltersForm.updateCardPrice(
            card,
            combinedPrice * bundleDiscountFactor,
            combinedPrice,
            $priceContainer.dataset.priceVaries === "true"
          );
        } else {
          const variantPriceStr = igData.price.getPriceByVariantId(variantId);
          if (!variantPriceStr) {
            return;
          }
          const variantTestPrice = parseFloat(variantPriceStr);
          if (isNaN(variantTestPrice)) {
            return;
          }
          const $priceContainer = card.querySelector(
            ".product-price-container"
          );
          const priceDiff =
            (parseFloat($priceContainer.dataset.comparePrice) -
              parseFloat($priceContainer.dataset.price)) /
            100;
          FacetFiltersForm.updateCardPrice(
            card,
            variantTestPrice,
            variantTestPrice + priceDiff,
            $priceContainer.priceVaries === "true"
          );
        }
      });
    } catch (error) {
      // Intelligems/parse error
    }
  }

  static updateURLHash(filterUrl) {
    history.pushState({ filterUrl }, "", filterUrl);
  }

  static getSections() {
    return [
      {
        section: document.getElementById("product-grid").dataset.id,
      },
    ];
  }

  onFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.substring(
      event.currentTarget.href.indexOf("/")
    );

    const filterButton = event.currentTarget;
    if (filterButton.classList.contains("collection-filter-link")) {
      const parentMenu = filterButton.closest(".collection-filter-menu");
      if (parentMenu) {
        Array.from(
          parentMenu.querySelectorAll(".btn--toggle-selected")
        ).forEach((button) => {
          button.classList.remove("btn--toggle-selected");
        });
        if (!filterButton.classList.contains("btn--toggle-selected")) {
          filterButton.classList.add("btn--toggle-selected");
        }

        this.scrollToActiveMenuItem(parentMenu, true);
      }
    }

    const parentDrawer = filterButton.closest("menu-drawer");
    if (parentDrawer) {
      parentDrawer.onCloseButtonClick(event);
    }

    FacetFiltersForm.renderPage(url);

    window.scrollTo({ top: 0, behavior: "smooth" });
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.filterUrlInitial =
  window.location.pathname + window.location.search;
FacetFiltersForm.filterUrlPrev = FacetFiltersForm.filterUrlInitial;
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

class FilterLinkButton extends HTMLElement {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
    const facetLink = this.querySelector("a");
    facetLink.setAttribute("role", "button");

    facetLink.addEventListener("click", this.handleClick);
    facetLink.addEventListener("keyup", (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === "SPACE") this.handleClick(event);
    });
  }

  handleClick(event) {
    const form =
      this.closest("facet-filters-form") ||
      document.querySelector("facet-filters-form");
    if (form) {
      form.onFilterClick(event);
    }
  }
}

customElements.define("filter-link-button", FilterLinkButton);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector("a");
    facetLink.setAttribute("role", "button");
    facetLink.addEventListener("click", this.closeFilter.bind(this));
    facetLink.addEventListener("keyup", (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === "SPACE") this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form =
      this.closest("facet-filters-form") ||
      document.querySelector("facet-filters-form");
    if (form) {
      form.onFilterClick(event);
    }
  }
}

customElements.define("facet-remove", FacetRemove);

if (window._INTELLIGEMS_READY) {
  FacetFiltersForm.updateCardPrices(
    document.getElementById("ProductGridContainer")
  );
} else {
  function handleIgMessageCollection(event) {
    if (event.data === "ig-ready") {
      window.removeEventListener("message", handleIgMessageCollection);
      FacetFiltersForm.updateCardPrices(
        document.getElementById("ProductGridContainer")
      );
    }
  }
  window.addEventListener("message", handleIgMessageCollection);
}
window.addEventListener("load", function () {
  FacetFiltersForm.updateCardPrices(
    document.getElementById("ProductGridContainer")
  );
});
